import "../../../../src/App.css";
import { avatar, x } from "../assets/Images";
const TestimonialSection = () => {
  return (
    <div className="hidden flex-col justify-center items-center mt-[60px] w-full">
      <div>
        <div className="flex items-center justify-center  bg-gray-900 w-[170px] py-4 rounded-full">
          <h1 className="text-white font-semibold text-[17px]">Reviews</h1>
        </div>
      </div>
      <div>
        <h1 className="text-gray-800  ubuntu-sans-h1 text-[50px] text-center font-semibold">
          What people are saying
        </h1>
      </div>
      <div className="w-full">
        <div className="flex flex-row justify-between mt-[70px] w-full">
          <div>
            <div className="h-[200px] w-[300px] rounded-3xl flex flex-col space-y-2 justify-start items-start border">
              <div className="w-full px-5 pt-8 ">
                <div className="flex flex-row w-full justify-between">
                  <div>
                    <div className="flex flex-row space-x-3">
                      <div>
                        <img
                          src={avatar}
                          className="h-[55px] md:h-[60px] rounded-full"
                          alt="Logo"
                        />
                      </div>
                      <div>
                        <div className="flex flex-col">
                          <div>
                            <h1 className="font-semibold text-[16px]">
                              Tedor Lupaka
                            </h1>
                          </div>
                          <div>
                            <h1 className="font-medium text-[16px] text-gray-300">
                              @lupakatedor
                            </h1>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div>
                    {" "}
                    <img
                      src={x}
                      className="h-[55px] md:h-[20px] rounded-full"
                      alt="Logo"
                    />
                  </div>
                </div>
              </div>
              <div className="px-5 text-gray-700">
                This is great! This app will really be helpful. I'll definitely
                be trying it out
              </div>
            </div>
          </div>

          <div>
            <div className="h-[200px] w-[300px] rounded-3xl flex flex-col space-y-2 justify-start items-start border">
              <div className="w-full px-5 pt-8 ">
                <div className="flex flex-row w-full justify-between">
                  <div>
                    <div className="flex flex-row space-x-3">
                      <div>
                        <img
                          src={avatar}
                          className="h-[55px] md:h-[60px] rounded-full"
                          alt="Logo"
                        />
                      </div>
                      <div>
                        <div className="flex flex-col">
                          <div>
                            <h1 className="font-semibold text-[16px]">
                              Tedor Lupaka
                            </h1>
                          </div>
                          <div>
                            <h1 className="font-medium text-[16px] text-gray-300">
                              @lupakatedor
                            </h1>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div>
                    {" "}
                    <img
                      src={x}
                      className="h-[55px] md:h-[20px] rounded-full"
                      alt="Logo"
                    />
                  </div>
                </div>
              </div>
              <div className="px-5 text-gray-700">
                This is great! This app will really be helpful. I'll definitely
                be trying it out
              </div>
            </div>
          </div>
          <div>
            <div className="h-[200px] w-[300px] rounded-3xl flex flex-col space-y-2 justify-start items-start border">
              <div className="w-full px-5 pt-8 ">
                <div className="flex flex-row w-full justify-between">
                  <div>
                    <div className="flex flex-row space-x-3">
                      <div>
                        <img
                          src={avatar}
                          className="h-[55px] md:h-[60px] rounded-full"
                          alt="Logo"
                        />
                      </div>
                      <div>
                        <div className="flex flex-col">
                          <div>
                            <h1 className="font-semibold text-[16px]">
                              Tedor Lupaka
                            </h1>
                          </div>
                          <div>
                            <h1 className="font-medium text-[16px] text-gray-300">
                              @lupakatedor
                            </h1>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div>
                    {" "}
                    <img
                      src={x}
                      className="h-[55px] md:h-[20px] rounded-full"
                      alt="Logo"
                    />
                  </div>
                </div>
              </div>
              <div className="px-5 text-gray-700">
                This is great! This app will really be helpful. I'll definitely
                be trying it out
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TestimonialSection;
